import Image from "../../../shared/ui/common/image";
import ChatRoom from "../pages/chat/chatRoom";
import { useBoothConversation } from "../hooks/use-booth-conversation";
import { Alert, Button } from "@mui/material";

/** Existing booth conversation view, owned by the messaging module. */
export default function BoothChat({ booth, RENDER }) {
  const { messages, loading, selected, connected, currentUserId, error, sendMessage, retry } = useBoothConversation(booth, RENDER);
  return (
    <>
      <div>
        <div className="flex gap-3 mb-3 items-center border-b">
          <Image
            className="md:w-10 w-6 h-6 md:h-10 rounded-full "
            src="/images/product1.svg"
            alt="product1"
            id={booth.logo}
          />{" "}
          <span className="text-[#61A6FF] text-base">{booth?.title}</span>
        </div>
        <ChatRoom
          converstions={messages}
          loading2={loading}
          id={selected?.id}
          currentUserId={currentUserId}
          connected={connected && !error}
          boothId={booth?.id}
          composerIdentity={`booth-${booth?.id}`}
          onSend={sendMessage}
        />
        {error && <Alert severity="error" action={<Button onClick={retry}>تلاش مجدد</Button>}>{error}</Alert>}
        <span role="status" className="text-xs">{connected && !error ? "متصل" : error ? "گفتگو در دسترس نیست" : "در حال اتصال"}</span>
      </div>
    </>
  );
}
